<template>
  <div>
    <div class="card-header pl-0">
      <div class="d-flex justify-content-between align-items-center">
        <div class="dropdown mr-3 d-none">
          <button
            class="btn btn-card-header dropdown-toggle"
            type="button"
            id="inspectorDropdown"
            data-toggle="dropdown"
            aria-expanded="false"
          >
            <img src="~@/assets/addplus_icon.svg" class="heading-icon mr-2"/>
            <span class="pr-2 text-capitalize"> Add</span>
          </button>

          <ul class="dropdown-menu" aria-labelledby="inspectorDropdown">
            <li class="d-none"><span class="dropdown-item" @click="activeComponent = 'default'">Default</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'main'">Main</span></li>
            <!-- <li><span class="dropdown-item" @click="activeComponent = 'animations'">Animations</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'light'">Light</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'sound'">Sound</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'movement'">Movement</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'effects'">Effects</span></li>
            <li><span class="dropdown-item" @click="activeComponent = 'tts'">TTS</span></li> -->
          </ul>
        </div>
        <span class="ml-3"><i class="fas fa-cogs"></i> Inspector</span>
        <span class="text-primary ml-3">
          {{ $parent.activeComponentTitle }}
        </span>

        <div v-if="!showModal && (selectedCharecterName || charData)" class="btn-menu-wrapper navbar navbar-expand-lg">
          <ul class="navbar-nav">
            <li class="nav-item">
              <span class="nav-link"
                    @click="activeComponent = 'main'"
                    :class="{'active':activeComponent == 'main'}">
                Main
              </span>
            </li>
             <!-- <li class="nav-item">
              <span class="nav-link"
                    @click="activeComponent = 'tts'"
                    :class="{'active':activeComponent == 'tts'}">
                Voice
              </span>
            </li> -->
            <!-- <li class="nav-item">
              <span class="nav-link"
                    @click="activeComponent = 'animations'"
                    :class="{'active':activeComponent == 'animations'}">
                Animation
              </span>
            </li> -->
             <li class="nav-item">
              <span
                class="nav-link"
                @click="activeComponent = 'movement'"
                :class="{ active: activeComponent == 'movement' }"
              >
                Movement
              </span>
            </li>
            <li class="nav-item">
              <span class="nav-link"
                    @click="activeComponent = 'effects'"
                    :class="{'active':activeComponent == 'effects'}">
                Effect
              </span>
            </li>
            <li class="nav-item">
              <span class="nav-link"
                    @click="activeComponent = 'light'"
                    :class="{'active':activeComponent == 'light'}">
                Light
              </span>
            </li>
            <li class="nav-item">
              <span class="nav-link"
                    @click="activeComponent = 'sound'"
                    :class="{'active':activeComponent == 'sound'}">
                Sound
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="inspector-wrapper">
        <template>
          <div class="row"></div>
          <div class="row">
            <div class="col-9">
              <maininspector
                v-if="activeComponent == 'main'"
                :selectedCharecter="selectedCharecter"
                :charData="charData"
                :currentIndex="currentIndex"
                @sendSelectedModelData="sendSelectedModelData"
                @setCharacterIndex="setCharacterIndex"
              ></maininspector>
              <animations
                v-if="activeComponent == 'animations'"
                @selectedAnimation=changeSelectedAnimation>
              </animations>
              <effects v-if="activeComponent == 'effects'"></effects>
              <light v-if="activeComponent == 'light'"></light>
              <movement v-if="activeComponent == 'movement'"></movement>
              <sound v-if="activeComponent == 'sound'"></sound>
              <tts v-if="activeComponent == 'tts'"></tts>
            </div>
            <div v-if="selectedCharecter" class="col-3 position-relative">
              <h4 v-if="selectedCharecter">{{ selectedCharecter.name }}</h4>
              <div class="selected-char-imgwrap">
                <img :src="propModels[selectedCharecter.objectDbHash].image.imageURL" class="img-fluid"/>
              </div>
            </div>
          </div>
          <div class="row mt-4 d-none">
            <div class="col-12 text-center">
              <button class="btn btn-outline-primary mr-3">Save</button>
              <button class="btn btn-outline-secondary">Cancel</button>
            </div>
          </div>
        </template>

        <template v-if="showModal">
          <div class="modal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" id="models-modal">
            <div class="modal-dialog modal-lg" role="document">

              <div class="modal-content">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal()">
                  <span aria-hidden="true">&times;</span>
                </button>

                <div class="modal-header">
                  <h4 class="text-center font-size-20">
                    3D Models
                  </h4>
                  <div class="clearfix"></div>
                </div>

                <div class="modal-body">
                  <models
                    @triggerSelectedModel="changeSelectedModel">
                  </models>
                </div>

              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import maininspector from '../inspector-components/models/maininspector'
import animations from '../inspector-components/models/animations'
import effects from '../inspector-components/models/effects'
import light from '../inspector-components/models/light'
import movement from '../inspector-components/models/movement'
import sound from '../inspector-components/models/sound'
import tts from '../inspector-components/models/tts'
import models from '../timeline-components/models'
import $ from 'jquery'
import {db} from '../../../../firebaseDB'
import { mapState } from 'vuex'

export default {
  name: 'modelsInspector',
  data () {
    return {
      currentIndex: 0,
      showModal: false,
      activeComponent: 'main',
      selectedCharecter: '',
      selectedCharecterName: '',
      charData: [],
      isLoading: true
    }
  },
  created () {
    this.$root.$on('trigger', id => {
      if(id === 1){
        this.triggerModal()
      }
    })
    // this.openModal()
    this.$root.$on('changeInspector', which => {
      this.activeComponent = which
    })
  },
  components: {
    models,
    maininspector,
    animations,
    effects,
    light,
    movement,
    sound,
    tts
  },mounted(){
  },
  watch:{
    charData(val){
      // console.log([...this.characters.filter(el => el.elementType != "Object3D") ,...val])
      // console.log(val)
      // this.$store.dispatch('updateCharacters', [...this.characters.filter(el => el.elementType != "Object3D") ,...val])
    },
    characters (val) {
      for (let i = 0; i < val.length; i++) {
        const char = val[i]
        if (char.active) {
          this.selectedCharecter = char
        }
      }
      // this.charData = val
    }
  },
  methods: {
    // async openModal () {
    //   let _this = this
    //   await db
    //     .ref()
    //     .child('stories')
    //     .orderByChild('user_id')
    //     .equalTo(this.$store.state.user.id)
    //     .on('value', function (snapShot) {
    //       _this.charData = []
    //       const data = snapShot.val()
    //       for (const snapShotKey in data) {
    //         if (snapShotKey === localStorage.getItem('storyId')) {
    //           _this.story = data[snapShotKey]
    //           if (_this.story && _this.story.json && _this.story.json.mainStory && _this.story.json.mainStory.nodes) {
    //             _this.story.json.mainStory.nodes.forEach(value => {
    //               if (value.hasOwnProperty('nodeElements')) {
    //                 value.nodeElements.forEach(value1 => {
    //                   if (value1.elementType === 'Object3D') {
    //                     _this.charData.push(value1.object3D)
    //                     _this.activeComponent = 'main'
    //                   }
    //                 })
    //               }
    //             })
    //           }
    //         }
    //       }
    //       if (_this.charData.length == 0) {
    //         _this.triggerModal()
    //       } else {
    //         _this.isLoading = false
    //       }
    //     })
    // },
    triggerModal () {
      this.showModal = true
      this.$nextTick(() => {
        $('#models-modal').modal('show')
      })
    },
    closeModal () {
      $('.modal').modal('hide')
      this.showModal = false
    },
    changeShadow () {
      this.$emit('showShadowChange', {'showShadow': this.showShadow})
    },
    changeSkeleton () {
      this.$emit('showSkeletonChange', {'showSkeletonToggle': this.showSkeleton})
    },
    changeSelectedAnimation (data) {
      this.$emit('showSelectedAnimation', {'selectedAnimation': data.selectedAnimation})
    },
    changeSelectedModel (data) {
      // this.selectedCharecter = data.model
      // this.selectedCharecterName = data.model.name
      // this.charData.push(this.selectedCharecter)
      // this.currentIndex = this.charData.length - 1
      // this.$emit('showSelectedModel', {'selectedFbxModel': data.index})
      this.closeModal()
      // this.isLoading = false
    },
    sendSelectedModelData (data) {
      this.selectedCharecter = data
      this.selectedCharecter = data
      this.$store.dispatch('updateTimeLine', {
        ...this.$store.state.inspector,
        main: {
          ...this.$store.state.inspector.main, model: {data}
        }
      })
    },
    setCharacterIndex (data) {
      this.currentIndex = data
    }
  },
  computed: {
    ...mapState(['characters', 'fbxModels','propModels'])
  }
}
</script>




// WEBPACK FOOTER //
// src/components/v2/story-edit-view/inspector-wrap/modelsInspector.vue